import React, 
{ 
    useEffect,
    useState,
} from 'react'

import toast from 'react-hot-toast';

import { 
  Form,
  Col, 
  Row,
  Space,
  Button,
  Checkbox,
  InputNumber,
  Modal,
  Table,
} from 'antd';

import { usePostRequest } from '../../hooks/usePostRequest'
import { useParams } from "react-router-dom" 

const { Item } = Form;

const OtherDuesTab = ({duesData, fetchMembersData, isLoading}) => {
    const [duesForm] = Form.useForm();
    const { id } = useParams() 
    const [duesModal, setDuesModal] = useState(false)
    // const [duesTableData, setDuesTableData] = useState([])
    const { callPost, loading } = usePostRequest(()=>{
        fetchMembersData();
    })

    const handleOpenModal = () => {
        setDuesModal(true)
    }


  const columns = [
        {
            title: 'Doc Seq ID',
            dataIndex: 'member_no',
            key: 'member_no',
            align: 'center',
            sorter: (a, b) => a.member_no.localeCompare(b.member_no),
        },
        {
            title: 'Doc Date',
            dataIndex: 'full_name',
            key: 'full_name',
            align: 'center',
        },
        {
            title: 'Reference',
            dataIndex: 'ar_cust_id',
            key: 'ar_cust_id',
            align: 'center',
        },
        {
            title: 'Particulars',
            dataIndex: 'ar_cust_id',
            key: 'ar_cust_id',
            align: 'center',
            width: '40%',
        },
        {
            title: 'Orig Amount',
            dataIndex: 'ar_cust_id',
            key: 'ar_cust_id',
            align: 'right',
        },
        {
            title: 'Balance',
            dataIndex: 'ar_cust_id',
            key: 'ar_cust_id',
            align: 'right',
        },
        
    ];

    const handleCreateDues = () => {
        duesForm.validateFields().then(values => {
            const newValues = {
                member_id: id,
                is_admission_due: values.is_admission_due ? "1" : "0",
                is_rule_book: values.is_rule_book ? "1" : "0",
                is_corp_credit_limit: values.is_corp_credit_limit ? "1" : "0",
                is_refundable_deposit: values.is_refundable_deposit ? "1" : "0",
                is_inhouse_card: values.is_inhouse_card ? "1" : "0",
                is_refdep: values.is_refdep ? "1" : "0",
                members_ledger: values.members_ledger,
                monthly_dues: values.monthly_dues,
                md_consumables: values.md_consumables,
                golf_cart_fee: values.golf_cart_fee,
                monthly_maint_payment: values.monthly_maint_payment,
                locker_rental: values.locker_rental,
                total: values.is_rule_book,
            }

            callPost(
                "members/update_dues", 
                newValues,
                false,
            );
        }).catch(errorInfo => {
            toast.error('Validation Failed ', errorInfo);
        });
    };

    useEffect(() => {
        if(duesData){
            duesForm.setFieldsValue({
                is_admission_due: duesData[0]?.is_admission_due === "1" ? true : false,
                is_rule_book: duesData[0]?.is_rule_book === "1" ? true : false,
                is_corp_credit_limit: duesData[0]?.is_corp_credit_limit === "1" ? true : false,
                is_refundable_deposit: duesData[0]?.is_refundable_deposit === "1" ? true : false,
                is_inhouse_card: duesData[0]?.is_inhouse_card === "1" ? true : false,
                is_refdep: duesData[0]?.is_refdep === "1" ? true : false,
                members_ledger: duesData[0]?.members_ledger,
                monthly_dues: duesData[0]?.monthly_dues,
                md_consumables: duesData[0]?.md_consumables,
                golf_cart_fee: duesData[0]?.golf_cart_fee,
                monthly_maint_payment: duesData[0]?.monthly_maint_payment,
                locker_rental: duesData[0]?.locker_rental,
                total: duesData[0]?.total,
            });

        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [duesData])

    return (
        <Row className='tab-container custom-padding'>
            <Col span={24}>
                <Form 
                    layout="vertical"
                    form={duesForm} 
                >
                    <Row className='responsive-inline responsive-width'>
                        <Col 
                            xs={8} sm={8} md={8} lg={8} xl={8}
                            className='p-2'
                        >
                            <Item
                                // label="Member's Ledger"
                                name="is_admission_due"
                                className='p-0 m-0'
                                valuePropName="checked"
                            >
                                <Checkbox>Admission Due</Checkbox>
                            </Item>
                        </Col>
                        <Col 
                            xs={8} sm={8} md={8} lg={8} xl={8}
                            className='p-2'
                        >
                            <Item
                                // label="Member's Ledger"
                                name="is_rule_book"
                                className='p-0 m-0'
                                valuePropName="checked"
                            >
                                <Checkbox>Rule Book</Checkbox>
                            </Item>
                        </Col>
                        <Col 
                            xs={8} sm={8} md={8} lg={8} xl={8}
                            className='p-2'
                        >
                            <Item
                                // label="Member's Ledger"
                                name="is_corp_credit_limit"
                                className='p-0 m-0'
                                valuePropName="checked"
                            >
                                <Checkbox>Corp Credit Limit</Checkbox>
                            </Item>
                        </Col>
                    </Row>
                    <Row className='responsive-inline responsive-width mb-4'>
                        <Col 
                            xs={8} sm={8} md={8} lg={8} xl={8}
                            className='p-2'
                        >
                            <Item
                                // label="Member's Ledger"
                                name="is_refundable_deposit"
                                className='p-0 m-0'
                                valuePropName="checked"
                            >
                                <Checkbox>Refundable Deposit</Checkbox>
                            </Item>
                        </Col>
                        <Col 
                            xs={8} sm={8} md={8} lg={8} xl={8}
                            className='p-2'
                        >
                            <Item
                                // label="Member's Ledger"
                                name="is_inhouse_card"
                                className='p-0 m-0'
                                valuePropName="checked"
                            >
                                <Checkbox>In-House Card</Checkbox>
                            </Item>
                        </Col>
                        <Col 
                            xs={8} sm={8} md={8} lg={8} xl={8}
                            className='p-2'
                        >
                            <Item
                                // label="Member's Ledger"
                                name="is_refdep"
                                className='p-0 m-0'
                                valuePropName="checked"
                            >
                                <Checkbox>Ref Dep GCart/Caddie</Checkbox>
                            </Item>
                        </Col>
                    </Row>
                    <Row className='responsive-inline responsive-width' align='center'>
                        <Space 
                            className='p-2'
                        >
                            <Item
                                label="Member's Ledger"
                                name="members_ledger"
                                className='p-0 m-0 space-width'
                            >
                                <InputNumber style={{width:'100%'}} disabled/>
                            </Item>
                        
                            <Button
                                className='dues-btn'
                                onClick={handleOpenModal}
                            >
                                ...
                            </Button>
                        </Space>
                    </Row>
                    <Row className='responsive-inline responsive-width' align='center'>
                        <Space 
                            className='p-2'
                        >
                            <Item
                                label="Monthly Dues"
                                name="monthly_dues"
                                className='p-0 m-0 space-width'
                            >
                                <InputNumber style={{width:'100%'}} disabled/>
                            </Item>
                            <Button
                                className='dues-btn'
                                onClick={handleOpenModal}
                            >
                                ...
                            </Button>
                        </Space>
                    </Row>
                    <Row className='responsive-inline responsive-width' align='center'>
                        <Space 
                            className='p-2'
                        >
                            <Item
                                label="MD Consumables"
                                name="md_consumables"
                                className='p-0 m-0 space-width'
                            >
                                <InputNumber style={{width:'100%'}} disabled/>
                            </Item>
                            <Button
                                className='dues-btn'
                                onClick={handleOpenModal}
                            >
                                ...
                            </Button>
                        </Space>
                    </Row>
                    <Row className='responsive-inline responsive-width' align='center'>
                        <Space 
                            className='p-2'
                        >
                            <Item
                                label="Golf Cart Service Fee"
                                name="golf_cart_fee"
                                className='p-0 m-0 space-width'
                            >
                                <InputNumber style={{width:'100%'}} disabled/>
                            </Item>
                            <Button
                                className='dues-btn'
                                onClick={handleOpenModal}
                            >
                                ...
                            </Button>
                        </Space>
                    </Row>
                    <Row className='responsive-inline responsive-width' align='center'>
                        <Space 
                            className='p-2'
                        >
                            <Item
                                label="Monthly Maint Payment"
                                name="monthly_maint_payment"
                                className='p-0 m-0 space-width'                            >
                                <InputNumber style={{width:'100%'}} disabled/>
                            </Item>
                            <Button
                                className='dues-btn'
                                onClick={handleOpenModal}
                            >
                                ...
                            </Button>
                        </Space>
                    </Row>
                    <Row className='responsive-inline responsive-width' align='center'>
                        <Space 
                            className='p-2'
                        >
                            <Item
                                label="Locker Rental"
                                name="locker_rental"
                                className='p-0 m-0 space-width'                            >
                                <InputNumber style={{width:'100%'}} disabled/>
                            </Item>
                            <Button
                                className='dues-btn'
                                onClick={handleOpenModal}
                            >
                                ...
                            </Button>
                        </Space>
                    </Row>
                    <Row className='responsive-inline responsive-width' align='center'>
                        <Space 
                            className='p-2'
                        >
                            <Item
                                label="TOTAL BALANCE"
                                name="total"
                                labelCol={{ className: 'bold-label' }}
                                className='p-0 m-0 space-width'                            >
                                <InputNumber style={{width:'100%'}} disabled/>
                            </Item>
                        </Space>
                    </Row>
                    <Row className='btn-footer'>
                        <Space className='p-2'>
                            <Button
                                onClick={handleCreateDues}
                                loading={loading}
                                type='primary'
                                className='button-color btn-header'
                            >
                                Save
                            </Button>
                        </Space>
                    </Row>
                </Form>
                <Modal
                    title="Transaction Breakdown"
                    // confirmLoading={loading}
                    open={duesModal}
                    // onOk={handleEditOk}
                    onCancel={() => setDuesModal(false)}
                    okText="Save"
                    maskClosable={false}
                    footer={null}
                    width={1300}
                >
                    <Row>
                        <Col span={24}>
                            <Table 
                                columns={columns} 
                                // dataSource={members} 
                                // loading={{
                                //     indicator: customSpinner,
                                //     spinning: isLoading,
                                // }}
                                pagination={false}                        
                            />
                        </Col>
                    </Row>
                    <Row>
                        <Col span={24} className='bold-total' align='right'>
                            TOTAL: 1,000,000
                        </Col>
                    </Row>
                </Modal>
            </Col>
        </Row>
    )
}
export default OtherDuesTab
